import * as PIXI from 'pixi.js';
import {IsPopupEnabled} from "./Popup";

class GameBoard {
  constructor(parent, width, height) {
    const maxScale = 2;
    const minScale = 1;
    const scaleSpeed = 0.1;
    this.currentScale = 1;
    this.container = new PIXI.Container();
    this.parent = parent;
    this.width = width;
    this.height = height;
    let texture = PIXI.Loader.shared.resources.bg.texture;
    this.background = new PIXI.Sprite(texture);
    if (height / width > texture.height / texture.width) {
      this.background.height = height;
      this.background.width = height * texture.width / texture.height;
    } else {
      this.background.width = width;
      this.background.height = width * texture.height / texture.width;
    }
    this.background.anchor.set(0.5);
    this.background.position.y = 0;
    this.dragging = false;
    this.background.interactive = true;
    this.background.on('pointerdown', this.onDragStart.bind(this))
      .on('pointerup', this.onDragEnd.bind(this))
      .on('pointerupoutside', this.onDragEnd.bind(this))
      .on('pointermove', this.onDragMove.bind(this));
    this.container.addChild(this.background);
    this.container.scale.set(this.currentScale);
    this.recenter();
    // document.addEventListener('mousewheel', (delta, event) => {
    //   if (IsPopupEnabled) return;
    //   let offset = Math.sign(delta.deltaY) * scaleSpeed;
    //   this.currentScale -= offset;
    //   this.currentScale = this.clamp(this.currentScale, minScale, maxScale)
    //   this.container.scale.set(this.currentScale);
    //   this.recenter();
    // });
  }


  onDragStart(event) {
    this.data = event.data;
    this.dragging = true;
    this.startPos = this.container.position;
    this.touchStart = this.data.getLocalPosition(this.parent);
  }

  onDragEnd() {
    this.dragging = false;
    // set the interaction data to null
    this.data = null;
  }

  recenter() {
    let maxOffsetX = this.calcOffsetX();
    let maxOffsetY = this.calcOffsetY();
    this.container.position.x = this.clamp(this.container.position.x, -maxOffsetX, maxOffsetX);
    this.container.position.y = this.clamp(this.container.position.y, -maxOffsetY, maxOffsetY);
  }

  calcOffsetX() {
    return (this.background.width - this.width / this.currentScale) / 1.5;
  }

  calcOffsetY() {
    return (this.background.height - this.height / this.currentScale) / 1.5;
  }

  onDragMove() {
    if (this.dragging) {
      let newPos = this.data.getLocalPosition(this.parent);
      let offsetX = newPos.x - this.touchStart.x;
      let offsetY = newPos.y - this.touchStart.y;
      let maxOffsetX = this.calcOffsetX();
      let maxOffsetY = this.calcOffsetY();
      this.container.position.x = this.clamp(this.startPos.x + offsetX, -maxOffsetX, maxOffsetX);
      this.container.position.y = this.clamp(this.startPos.y + offsetY, -maxOffsetY, maxOffsetY + 50);
      this.touchStart = newPos;
    }
  }

  clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
  }
}

export default GameBoard;
